export default __webpack_public_path__ + "static/media/Logo.844b2521.png";